import React from 'react';
import { Box, Text, BoxProps, chakra } from '@chakra-ui/react';
import { ReactComponent as InfoIconSvg } from 'resources/images/info-icon.svg';

interface ExtendedBoxProps extends BoxProps {
  'data-testid'?: string;
}

interface MessageBoxProps {
  children: React.ReactNode;
  boxProps?: ExtendedBoxProps;
}

const rootProps: BoxProps = {
  display: 'flex',
  flexDirection: 'row',
  bg: 'B.10',
  border: '1px solid transparent',
  rounded: 4,
  px: 2,
  py: 3,
};

const InfoIcon = chakra(InfoIconSvg);

export const MessageBox = ({ children, boxProps }: MessageBoxProps) => (
  <Box {...rootProps} {...boxProps}>
    <InfoIcon color="M.70" />
    <Text fontSize="xs" pl={2}>
      {children}
    </Text>
  </Box>
);
